/**
 * Safe Sentry helper - usa window.Sentry inicializado em main.tsx
 * Elimina necessidade de dynamic imports
 */

const S = (typeof window !== 'undefined' ? (window as any).Sentry : undefined);

export const captureException = (err: unknown, context?: any) => {
  try {
    S?.captureException?.(err, context);
  } catch {
    if (!import.meta.env.PROD) {
      console.error('captureException (dev):', err);
    }
  }
};

export const captureMessage = (msg: string, level?: any) => {
  try {
    S?.captureMessage?.(msg, level);
  } catch {
    if (!import.meta.env.PROD) {
      console.log('captureMessage (dev):', msg);
    }
  }
};
